module.exports = __webpack_public_path__ + "img/horizontal_4_4_8017.5bacb983.png";